<ng-container
  *ngIf="
    (isReadOnly || bindingFormControl?.readonly) && !isBinary;
    else templateLayout
  "
>
  <div
    sigvValueDiffItem="contractFormat"
    class="p-text-bold-500"
    *ngIf="!showCheckBoxWhenReadonly"
  >
    {{
      bindingFormControl?.value
        | multiOptionsMapping : selectOptions
        | replaceNullWith : '-'
    }}
    <ng-container *ngIf="otherCommentFormControl?.value">
      <span>(</span>
      {{ otherCommentFormControl?.value }}
      <span>)</span>
    </ng-container>
  </div>
  <div
    sigvValueDiffItem="contractFormat"
    class="p-text-bold-500"
    *ngIf="isTemplate && showCheckBox; else readOnlyWithCheckBox"
  >
    <div *ngTemplateOutlet="templateLayout"></div>
  </div>
  <ng-template #readOnlyWithCheckBox>
    <div *ngIf="showCheckBoxWhenReadonly" class="p-grid">
      <div class="d-flex flex-align-center flex-wrap p-checkbox-horizon">
        <sigv-form-control-widget
          [fieldName]="fieldName"
          [bindingFormControl]="bindingFormControl"
        >
          <ng-container *ngFor="let selectOption of selectOptions">
            <p-checkbox
              [formControl]="value"
              [readonly]="isReadOnly || bindingFormControl?.readonly"
              [disabled]="isReadOnly || bindingFormControl?.readonly"
              [label]="selectOption.label | replaceNullWith : '' | translate"
              [value]="selectOption.value"
              class="p-mb-2"
              (onChange)="onChangeEvent($event, selectOption.value)"
              [binary]="isBinary"
            >
            </p-checkbox>
          </ng-container>
        </sigv-form-control-widget>
      </div>
    </div>
  </ng-template>
</ng-container>

<ng-template #templateLayout>
  <div *ngIf="isTemplate; else showInputCheckbox">
    <!-- Template Layout -->
    <div class="p-grid" style="width: 100%">
      <div
        class="d-flex flex-align-center flex-wrap p-checkbox-horizon"
        style="width: 100%"
      >
        <ng-container *ngFor="let selectOption of selectOptions">
          <sigv-form-control-widget
            *ngIf="selectOption.value != otherCommentValue"
            [fieldName]="fieldName"
            [bindingFormControl]="bindingFormControl"
          >
            <p-checkbox
              [formControl]="value"
              [readonly]="isReadOnly || bindingFormControl?.readonly"
              [label]="selectOption.label | replaceNullWith : '' | translate"
              [value]="selectOption.value"
              class="p-mb-2 checkbox-width"
              (onChange)="onChangeEvent($event, selectOption.value)"
              [binary]="isBinary"
            >
            </p-checkbox>
          </sigv-form-control-widget>
        </ng-container>
      </div>
    </div>
    <div class="p-grid" style="width: 100%">
      <div
        class="d-flex flex-align-center flex-wrap p-checkbox-horizon"
        style="width: 100%"
      >
        <ng-container *ngFor="let selectOption of selectOptions">
          <sigv-form-control-widget
            *ngIf="selectOption.value === otherCommentValue"
            [fieldName]="fieldName"
            [bindingFormControl]="bindingFormControl"
          >
            <p-checkbox
              [formControl]="value"
              [readonly]="isReadOnly || bindingFormControl?.readonly"
              [disabled]="isReadOnly || bindingFormControl?.readonly"
              [label]="selectOption.label | replaceNullWith : '' | translate"
              [value]="selectOption.value"
              class="p-mb-2 checkbox-width"
              (onChange)="onChangeEvent($event, selectOption.value)"
              [binary]="isBinary"
            >
            </p-checkbox>
          </sigv-form-control-widget>
          <sigv-input-text
            *ngIf="
              selectOption.value === otherCommentValue &&
              value.value?.includes(otherCommentValue) &&
              otherCommentFormControl
            "
            [bindingFormControl]="otherCommentFormControl"
            [isReadOnly]="isReadOnly"
            [maxlength]="200"
          ></sigv-input-text>
        </ng-container>
      </div>
    </div>
  </div>
</ng-template>
<ng-template #showInputCheckbox>
  <div
    *ngIf="
      isVertical && !(isBinary && (isReadOnly || bindingFormControl?.readonly));
      else horizontalLayout
    "
  >
    <!-- Vertical Layout -->
    <div class="p-grid">
      <div class="flex flex-column p-checkbox-horizon">
        <div
          *ngFor="let selectOption of selectOptions"
          class="flex align-items-center justify-content-start p-mb-2"
        >
          <sigv-form-control-widget
            [fieldName]="fieldName"
            [bindingFormControl]="bindingFormControl"
          >
            <p-checkbox
              [formControl]="value"
              [readonly]="isReadOnly || bindingFormControl?.readonly"
              [label]="selectOption.label | replaceNullWith : '' | translate"
              [value]="selectOption.value"
              [disabled]="disabled"
              (onChange)="onChangeEvent($event, selectOption.value)"
            ></p-checkbox>
          </sigv-form-control-widget>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #horizontalLayout>
  <div
    *ngIf="
      !(isBinary && (isReadOnly || bindingFormControl?.readonly));
      else binaryDisableLayout
    "
  >
    <!-- Horizontal Layout -->
    <div class="p-grid">
      <div class="d-flex flex-align-center flex-wrap p-checkbox-horizon">
        <sigv-form-control-widget
          [fieldName]="fieldName"
          [bindingFormControl]="bindingFormControl"
        >
          <ng-container *ngFor="let selectOption of selectOptions">
            <p-checkbox
              [formControl]="value"
              [readonly]="isReadOnly || bindingFormControl?.readonly"
              [label]="selectOption.label | replaceNullWith : '' | translate"
              [value]="selectOption.value"
              class="p-mb-2"
              (onChange)="onChangeEvent($event, selectOption.value)"
              [binary]="isBinary"
            >
            </p-checkbox>
          </ng-container>
        </sigv-form-control-widget>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #binaryDisableLayout>
  <div *ngIf="!showLabel; else binaryDisableLayoutWithLabel">
    <!-- Binary Disable Layout -->
    <div class="p-grid">
      <div class="d-flex flex-align-center flex-wrap p-checkbox-horizon">
        <ng-container *ngFor="let selectOption of selectOptions">
          <sigv-form-control-widget
            [fieldName]="fieldName"
            [bindingFormControl]="bindingFormControl"
          >
            <p-checkbox
              [disabled]="true"
              [ngModel]="bindingFormControl.getRawValue()"
              [binary]="true"
            >
            </p-checkbox>
          </sigv-form-control-widget>
        </ng-container>
      </div>
    </div>
  </div>
  <ng-template #binaryDisableLayoutWithLabel>
    <!-- Binary Disable Layout With Label -->
    <div class="p-grid">
      <div class="d-flex flex-align-center flex-wrap p-checkbox-horizon">
        <ng-container *ngFor="let selectOption of selectOptions">
          <sigv-form-control-widget
            [fieldName]="fieldName"
            [bindingFormControl]="bindingFormControl"
          >
            <p-checkbox
              [disabled]="true"
              [ngModel]="bindingFormControl.getRawValue()"
              [binary]="true"
              [label]="selectOption.label | replaceNullWith : '' | translate"
            >
            </p-checkbox>
          </sigv-form-control-widget>
        </ng-container>
      </div>
    </div>
  </ng-template>
</ng-template>
